import styled from "styled-components";
import { shade } from "polished";

export const Container = styled.button`
  background: var(--light-orange);
  color: var(--var-grey-70);
  font-weight: 500;
  margin-top: 16px;
  border-radius: 10px;
  border: 0;
  padding: 0 14px;
  height: 50px;
  width: 100%;
  transition: background 0.2s;

  &:hover {
    background: ${shade(0.05, "#f39016ff")};
  }
`;
